import { ServicingRole, ServicingRoleForUpdate, AllowedUserForServicingRole } from '@/types/v2/Policy';
import { isAxiosError, Service } from '../api';
import { AxiosResponse } from 'axios';
import { AuditLog } from '@/types/AuditLog';

class PolicyService extends Service {
  async getPolicyLineServicingRoles(policyID: number, policyLineID?: number): Promise<ServicingRole[]> {
    const params: Record<string, number> = { policyID };
    if (policyLineID !== undefined) {
      params.policyLineID = policyLineID;
    }
    return this.get<ServicingRole[]>('/v2/policy-line-servicing-roles', params).then(this.handleResponse);
  }

  async updatePolicyLineServicingRoles(
    policyID: number,
    policyLineID: number | undefined,
    servicingRoles: ServicingRoleForUpdate[],
  ): Promise<AxiosResponse> {
    const body: { policyID: number; policyLineID?: number; roles: ServicingRoleForUpdate[] } = {
      policyID,
      roles: servicingRoles,
    };
    if (policyLineID !== undefined) {
      body.policyLineID = policyLineID;
    }

    const response = await this.post('/v2/policy-line-servicing-roles', body);

    if (isAxiosError(response)) {
      throw new Error(`Failed to update servicing roles: ${response.message}`);
    }

    return response;
  }

  async getPolicyLineServicingRolesAuditHistory(policyID: number): Promise<AuditLog[]> {
    return this.get<AuditLog[]>('/v2/policy-line-servicing-roles-audit-history', { policyID }).then(this.handleResponse);
  }

  async getAllowedUsersForServicingRoles(): Promise<AllowedUserForServicingRole[]> {
    return this.get<AllowedUserForServicingRole[]>('/v2/allowed-users-for-servicing-roles', {}).then(this.handleResponse);
  }
}

export const policyService = new PolicyService();
